import { api } from '@/api'
import qs from 'qs'

interface Params {
  include?: string
  q?: any
  page?: number
  perPage?: number
}

export default {
  get: ({ include, q, page, perPage }:Params) => {
    return api.$get('/settings/work_orders/invoice_statuses', {
      params: {
        include,
        q,
        page,
        per_page: perPage
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })
  }
}
